import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import * as bootstrap from "bootstrap";

const accessToken = document.querySelector("#tokenmapboxsite")?.value;
mapboxgl.accessToken = accessToken;

const siteMapContainer = document.getElementById('site-map');

if (siteMapContainer) {
    const lat = siteMapContainer.dataset.lat;
    const lng = siteMapContainer.dataset.lng;
    const siteName = siteMapContainer.dataset.siteName;

    if (lat && lng) {
        const coords = [parseFloat(lng), parseFloat(lat)];

        // Mapa pequeño (en la página)
        const map = new mapboxgl.Map({
            container: 'site-map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center: coords,
            zoom: 12
        });

        // Crear popup con información del sitio
        const popup = new mapboxgl.Popup({ offset: 25 })
            .setHTML(`<strong>${siteName}</strong>`);

        // Crear marcador
        const marker = new mapboxgl.Marker()
            .setLngLat(coords)
            .setPopup(popup)
            .addTo(map);

        // Hacer el mapa clickeable para abrir modal
        let mapInitialized = false;
        siteMapContainer.addEventListener('click', function(e) {
            // Prevenir que se abra el popup del marcador
            if (!e.target.classList.contains('mapboxgl-marker')) {
                const modalElement = document.getElementById('siteMapModal');
                const modal = new bootstrap.Modal(modalElement);
                modal.show();

                // Inicializar mapa en el modal cuando se abra
                if (!mapInitialized) {
                    // Esperar a que el modal esté completamente visible
                    modalElement.addEventListener('shown.bs.modal', function initMapModal() {
                        const mapModalContainer = document.getElementById('site-map-modal');
                        if (mapModalContainer && mapModalContainer.offsetHeight > 0) {
                            const mapModal = new mapboxgl.Map({
                                container: 'site-map-modal',
                                style: 'mapbox://styles/mapbox/streets-v11',
                                center: coords,
                                zoom: 14
                            });

                            // Crear popup con información
                            const popupModal = new mapboxgl.Popup({ offset: 25 })
                                .setHTML(`<strong>${siteName}</strong>`);

                            // Crear marcador
                            const markerModal = new mapboxgl.Marker()
                                .setLngLat(coords)
                                .setPopup(popupModal)
                                .addTo(mapModal);

                            mapInitialized = true;
                            // Remover listener después de inicializar
                            modalElement.removeEventListener('shown.bs.modal', initMapModal);
                        }
                    }, { once: true });
                }
            }
        });

    }
}
